<template>
  <div class="content create-issue">
    <loading v-if="loading" text='Loading. Please wait...'/>
    
    <div class="success" v-else-if="submitSuccess">
      <i class="fas fa-check"></i> Thank you! Your issue has been logged successfully on Gitlab.
      <div style="padding: 10px">
        <button class="button is-primary" @click="submitSuccess=false">Log another issue</button>
      </div>
    </div>

    <div v-else>
      <h1>
        Report an Issue
      </h1>
      <div class="form"> 
        <div class="field">
          <label class="label">Issue Title *</label>
          <div class="control has-icons-right">
            <input class="input" type="text" v-model="title" placeholder="e.g. Critical: PDF resource is not opening">
            <span class="icon is-small is-right" v-if="!title && submitAttempted">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
          </div>
          <p class="help is-danger" v-if="!title && submitAttempted">This field is required</p>
        </div>
        <div class="field">
          <label class="label">Description *</label>
          <div class="control has-icons-right">
            <textarea class="textarea" placeholder="Detailed description of what is happening" v-model="description"></textarea>
            <span class="icon is-small is-right" v-if="!description && submitAttempted">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
          </div>
          <p class="help is-danger" v-if="!description && submitAttempted">This field is required</p>
        </div>

        <button class="button is-primary is-pulled-right" @click="createIssue()">Create</button>

        <span v-show="error" class="help is-danger">{{error}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import error from '@/utils/error.js'
  
  export default {
    name: 'CreateIssue',
    components: {
    },
    data: function () {
      var t = this;

      return {
        title: "",
        description: "",
        error: "",
        submitAttempted: false,
        submitSuccess: false,
        loading: false,
        comingSoon: false
      }
    },
    mounted() {
    },
    methods: {
      createIssue: function() {
        var t = this;
        t.submitAttempted = false;
        t.loading = true;

        var descriptionWithLogs = t.description + 
          '\n\nServer: `' + window.location.host + 
          '`\n\nUsername: `' + utils.uriEncode(t.$store.state.user.username) + 
          '`\n\nLogs:\n\n```\n' + t.$store.state.errorLogs.join('\n\n') + '\n```';

        var params = "?title="+encodeURI(t.title)+"&description="+encodeURI(descriptionWithLogs);
        axios.post("https://gitlab.it.si/api/v4/projects/"+363+"/issues"+params,{}, {
            headers: {
                'PRIVATE-TOKEN': 'Pddusz_hD-WXX1xp6CAe'
            }
        }).then(response => {
          t.description = '';
          t.tile = '';
          t.submitSuccess = true;
          t.loading = false;
          t.$store.commit('clearErrorLogs','');
        })
        .catch(e => {
            t.error = error.logAndGetError(t, e);
            t.loading = false;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.create-issue {
  .form {
    padding-bottom: 100px;
  }

  text-align: left;

  input {
    margin-top: 0;
  }

  .success {
    color: $success-color;
    font-size: 13pt;
    margin-top: 20px;
    text-align: center;
  }
}

</style>